import React, { useState } from 'react';
import Formviewer from './Formviewer';
import {formsData} from './Constants';
import '../css/Forms.css';

const Forms = () => {
  const [viewFormName, setViewFormName] = useState(null);
  const [searchText, setSearchText] = useState('');

  const filteredForms = formsData.filter(f =>
    f.name.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="main">
      {!viewFormName ? (
        <>
          <div className="report-container11">
            <div className="report-header">
              <h1 className="recent-Articles">All Tables</h1>
              <input
                className="search-input"
                type="text"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="report-body11">
              <table className="report-table">
                <thead>
                  <tr><th>Sr.</th><th>Name</th><th>Description</th></tr>
                </thead>
                <tbody>
                  {filteredForms.map((form, index) => (
                    <tr
                      key={index}
                      onClick={() => setViewFormName(form.name)}
                      style={{ cursor: 'pointer' }}
                    >
                      <td>{index + 1}</td>
                      <td>{form.name}</td>
                      <td style={{ textAlign: 'justify' }}>{form.description || 'No description available'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <Formviewer formName={viewFormName} onBack={() => setViewFormName(null)} />
      )}
    </div>
  );
};

export default Forms;